export const SET_SHOP_COUNTERS = 'SET_SHOP_COUNTERS';
export const RECALCULATE_ARRANGEMENTS_COUNT = 'RECALCULATE_ARRANGEMENTS_COUNT';
export const RECALCULATE_LESSONS_COUNT = 'RECALCULATE_LESSONS_COUNT';
export const RECALCULATE_MODERATOR_ARRANGEMENTS_COUNT = 'RECALCULATE_MODERATOR_ARRANGEMENTS_COUNT';
export const RECALCULATE_MODERATOR_LESSONS_COUNT = 'RECALCULATE_MODERATOR_LESSONS_COUNT';

export const SET_SHOP_TAGS = 'SET_SHOP_TAGS';
export const SET_SHOP_COMPOSERS = 'SET_SHOP_COMPOSERS';
export const SET_SHOP_PERFORMERS = 'SET_SHOP_PERFORMERS';
export const SET_SHOP_FILMS = 'SET_SHOP_FILMS';
export const SET_SHOP_DIFFICULTIES = 'SET_SHOP_DIFFICULTIES';
export const SET_SHOP_TONALITIES = 'SET_SHOP_TONALITIES';

export const SET_OFFERS_FORM_INFO = 'SET_OFFERS_FORM_INFO';

export const SET_OFFERS_LIST= 'SET_OFFERS_LIST';

export const SET_MODER_OFFERS_LIST= 'SET_MODER_OFFERS_LIST';

export const REMOVE_OFFER = 'REMOVE_OFFER';

export const CREATE_OFFER = 'CREATE_OFFER';

export const SET_OFFER_FOR_UPDATE = 'SET_OFFER_FOR_UPDATE';
export const SET_UPDATED_FILES = 'SET_UPDATED_FILES';
export const SET_HIDE_DELETE_FILES_ACTIONS = 'SET_HIDE_DELETE_FILES_ACTIONS';
export const CLEAR_INITIAL_VALUES = 'CLEAR_INITIAL_VALUES';
export const CLEAR_UPDATED_FILES = 'CLEAR_UPDATED_FILES';
export const CLEAR_HIDE_DELETE_FILES_ACTIONS = 'CLEAR_HIDE_DELETE_FILES_ACTIONS';

export const UPDATE_OFFER = 'UPDATE_OFFER';
export const UPDATE_OFFER_PARTIAL = 'UPDATE_OFFER_PARTIAL';
export const UPDATE_MODERATOR_OFFER_PARTIAL = 'UPDATE_MODERATOR_OFFER_PARTIAL';


